import { useQuery } from '@tanstack/react-query'
import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'
import { idsEqual, type HierarchyNode } from '@/features/hierarchy/hierarchy'

/**
 * Direct children of `parentId` at a hierarchy level (Lab cascade TM→DM→SM→M).
 * Uses CM-API `POST /v1/hierarchy/tree` with `rootId`.
 */
export function useCommissionDownline(
  parentId: string | undefined,
  level: number,
  enabled = true,
) {
  return useQuery({
    queryKey: ['commission-eligibility', 'downline', parentId ?? '', level] as const,
    enabled: enabled && Boolean(parentId),
    staleTime: 60_000,
    queryFn: async (): Promise<HierarchyNode[]> => {
      if (!parentId) return []
      const tree = await cmApi.hierarchyTree(authHeaders(), parentId)
      return (tree.nodes ?? []).filter(
        (n) => n.level === level && idsEqual(n.parentId, parentId),
      )
    },
  })
}
